import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: 'var(--bg-subtle)' }}>
      <div className="text-center max-w-sm">
        <p className="text-6xl font-semibold mb-4" style={{ fontFamily: 'var(--font-serif)', color: 'var(--gold)', opacity: 0.5 }}>404</p>
        <h1 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'var(--font-serif)', color: 'var(--text)' }}>Page not found</h1>
        <p className="text-sm mb-6" style={{ color: 'var(--text-muted)' }}>The page you’re looking for doesn’t exist or has been moved.</p>
        <Link to="/">
          <Button style={{ backgroundColor: 'var(--text)', color: 'white', borderRadius: '10px' }}>Return home</Button>
        </Link>
      </div>
    </div>
  );
}
